export const Compass = {
    start: (degrees, cb) => {},
    stop: () => {},
};
